module.exports = __webpack_public_path__ + "img/boy-with-phone.546c2c6b.webp";